export const AWS_CONFIG = {
  region: 'ap-northeast-2',
  cognito: {
    userPoolId: 'ap-northeast-2_pGde7YAAi',
    userPoolClientId: '6g5jotu1a8eociump9ah1a9tlu',
  },
  apiUrl: 'https://qdtjpudqk3.execute-api.ap-northeast-2.amazonaws.com/prod',
  google: {
    clientId: '521172048094-8skj71i1oqijmud4ppui8qcgs0kq65rh.apps.googleusercontent.com',
  },
  naver: {
    clientId: 'vpAcO18pJTcvaoXa6bHi',
  },
  kakao: {
    restApiKey: '7635894f3e571da9cb8e62101152f124',
  },
};
